import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

/**
 * Syncs the logged-in Supabase user's UUID with OneSignal as the external_id.
 * This lets the onesignal-push edge function target individual users via include_aliases.
 */
export function OneSignalIdentity() {
  useEffect(() => {
    const sync = (uid?: string | null) => {
      const w = window as unknown as { OneSignalDeferred?: Array<(os: any) => void> };
      w.OneSignalDeferred = w.OneSignalDeferred || [];
      w.OneSignalDeferred.push(async (OneSignal: any) => {
        try {
          if (uid) {
            await OneSignal.login(String(uid));
          } else {
            await OneSignal.logout();
          }
        } catch (e) {
          // eslint-disable-next-line no-console
          console.warn("[OneSignal] identity sync failed", e);
        }
      });
    };

    supabase.auth.getSession().then(({ data }) => sync(data.session?.user.id ?? null));
    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
      sync(session?.user.id ?? null);
    });
    return () => sub.subscription.unsubscribe();
  }, []);

  return null;
}
